import React from "react";
import { InformationMessage } from "nemuru-components";
import { helpingMessages } from "../config";
import Text from "../../../../../shared/components/Text";

export default function ElectronicIdError({ errorResponse }) {
  const helpMessage = helpingMessages[errorResponse?.notification?.name]
    ? {
        type: helpingMessages[errorResponse?.notification?.name].type,
        title: <Text tId="ELECTRONIC_ID_ERROR_TITLE" />,
        body: (
          <Text
            tId={helpingMessages[errorResponse?.notification?.name].textId}
          />
        ),
      }
    : {
        type: "error",
        title: <Text tId="ELECTRONIC_ID_ERROR_TITLE" />,
        body: errorResponse?.notification?.data?.texts?.description,
      };

  return (
    <>
      <InformationMessage
        className="information-message"
        variant={{
          type: helpMessage.type,
          icon: (
            <i className="material-icons-outlined" style={{ fontSize: 26 }}>
              {helpMessage.type === "warning" && "warning"}
              {helpMessage.type === "error" && "error"}
            </i>
          ),
        }}
        isScreenXs={false}
        messageContent={{
          title: helpMessage.title,
          body: helpMessage.body,
        }}
      />
    </>
  );
}
